//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "live",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '2',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-2.vue